export const prettyPrintRoute = route => `${route.name}, path=${route.path}`

export const useAccessControl = () => ({
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.meta?.accionCodigo) {
        if ('acreditaRuta' in vm) {
          // si la accion NO está acreditada por el usuario, ó
          // entonces, redirecciona al Home
          if (!vm.acreditaRuta(to)) {
            process.env.VUE_APP_ENV !== 'production' &&
              console.warn(
                `Se redirecciona al home porque el usuario no acredita la ruta ${prettyPrintRoute(
                  to
                )}`
              )
            next({ name: 'Home' })
            return
          }
        } else {
          const name = vm.$options?.name || ''
          throw new Error(
            `El componente ${name} está asociado a la ruta ${prettyPrintRoute(
              to
            )}, con accionCodigo=${
              to.meta.accionCodigo
            }, y debe incluir el mixin "useAcreditacionServicio" de "@colescba/ui", en donde se define el método "acreditaRuta"`
          )
        }
      }

      next()
    })
  },
})
